import { css } from 'linaria';

export namespace Styles {
  export const formSubmitNotification = css`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    margin-bottom: 24px;
  `;

  export const formSubmitNotificationIconHolder = css`
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 40px;
    height: 40px;
  `;

  export const formSubmitNotificationIcon = css`
    width: 40px;
    height: 40px;
    animation: rotate 2s infinite;
    fill: #5ab030;

    @keyframes rotate {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `;

  export const formSubmitNotificationContent = css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-left: 16px;
  `;

  export const formSubmitNotificationTitle = css`
    margin-bottom: 4px;
  `;
}
